import { InputValueType } from './Input'
import { formatInputToCurrency } from '../../utils/formatInputToCurrency'

export interface FormDisplayData {
  raw: number | string | undefined | readonly string[] | null
  display: string
}

export const currencyFormatter = (value: InputValueType): FormDisplayData => {
  const fieldData: FormDisplayData = {
    raw: null,
    display: '',
  }

  if (!value || typeof value !== 'string') {
    return fieldData
  }

  // Remove any commas from the formatted number
  const amt = Number.parseFloat(value.replace(/,/g, ''))

  // Don't accept any other values except valid numbers and decimals
  if (!Number.isNaN(amt) || value === '.') {
    fieldData.raw = amt
    fieldData.display = formatInputToCurrency(value)
  }
  return fieldData
}
